import './shared/sentry';

const w = window as any;

import './knockoutDeprecated/KnockoutExtenders';
import './knockoutDeprecated/KnockoutValidationExtenders';

import ko from 'knockout';
w.ko = ko;

import Dropzone from './shared/dropzone';
w.Dropzone = Dropzone;

import { Utils } from './shared/Utils';

import { Locale, setDefaultOptions } from 'date-fns';
import { da, enGB, nb } from 'date-fns/locale';

const cultureQuery = Utils.getParameterByName('culture');
const cultureCookie = decodeURIComponent(
    Utils.getCookie('.AspNetCore.Culture') ?? '',
);

const formatRelativeLocale: any = {
    lastWeek: R.dateFnsLongDateTimeFormat,
    yesterday: R.dateFnsLongDateTimeFormat,
    today: R.dateFnsTodayRelativeFormat,
    tomorrow: R.dateFnsTomorrowRelativeFormat,
    nextWeek: R.dateFnsLongDateTimeFormat,
    other: R.dateFnsLongDateTimeFormat,
};

if (cultureQuery == 'en' || cultureCookie == 'c=en|uic=en') {
    setLocale(enGB);
} else if (cultureQuery == 'nb' || cultureCookie == 'c=nb|uic=nb') {
    setLocale(nb);
} else {
    setLocale(da);
}

function setLocale(locale: Locale) {
    setDefaultOptions({
        locale: {
            ...locale,
            formatRelative: (token: string) => formatRelativeLocale[token],
        },
    });
}

import { ConsultationTypeEnum } from './shared/enums';
import { Log } from './shared/Log';
import { Heartbeat } from './shared/heartbeat';
import { AlertViewModel } from './knockoutDeprecated/viewModels/AlertViewModel';
import { RateConsultation } from './knockoutDeprecated/viewModels/consultations/RateConsultationViewModel';
import { ProfileInsuranceViewModel } from './knockoutDeprecated/viewModels/ProfileInsuranceViewModel';
import { ConsultationDetailsViewModel } from './knockoutDeprecated/viewModels/consultations/ConsultationDetailsViewModel';
import { ClockValidatorApp } from './features/clockValidator/ClockValidatorApp';
import { R } from '@/Resources.resx';
import { FileUploadDietitianApp } from '@/features/fileUpload/FileUploadDietitianApp';
import { ProgramsApp } from '@/features/programs/app/ProgramsApp';
import { WeightChartApp } from '@/features/weightChart/App';
import { BookingApp } from '@/features/booking/app/App';
import { setupBmiApp } from '@/features/bmi';
import { ProfileApp } from '@/features/profile/app/ProfileApp';
import { PfaPhysiotherapyApp } from '@/features/pfaPhysiotherapy/app/PfaPhysiotherapyApp';
import { ApTicketOfficeApp } from '@/features/apTicketOffice/app/ApTicketOfficeApp';

w.Hejdoktor = {
    Utils: Utils,
    ConsultationTypeEnum: ConsultationTypeEnum,
    Log: Log,
    AlertViewModel: AlertViewModel,
    RateConsultation: RateConsultation,
    ProfileInsuranceViewModel: ProfileInsuranceViewModel,
    ConsultationDetailsViewModel: ConsultationDetailsViewModel,
    Heartbeat: Heartbeat,
    ClockValidatorApp: ClockValidatorApp,
    FileUploadDietitianApp: FileUploadDietitianApp,
    ProgramsApp: ProgramsApp,
    LineChartApp: WeightChartApp,
    ProfileApp: ProfileApp,
    BookingApp: BookingApp,
    SetupBmiApp: setupBmiApp,
    PfaPhysiotherapyApp: PfaPhysiotherapyApp,
    ApTicketOfficeApp: ApTicketOfficeApp,
};
